import PropTypes from 'prop-types';
import { UnstyledButton, Avatar, Box, Text, ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { getNotificationConfig, formatRelativeTime } from 'utils/notification-helpers';
import { semanticColors } from 'theme';
import classes from './NotificationItem.module.css';

const NotificationItem = ({ notification, onClick, onDelete }) => {
  const { icon: Icon, color } = getNotificationConfig(notification.type, notification.priority);

  return (
    <Box className={classes.item} data-unread={notification.is_read ? undefined : true}>
      <UnstyledButton className={classes.main} onClick={() => onClick(notification)}>
        <Avatar
          size={42}
          radius="xl"
          style={{
            backgroundColor: `${color}12`,
            flexShrink: 0,
            marginTop: 2
          }}
        >
          <Icon size={22} color={color} stroke={1.5} />
        </Avatar>

        <Box style={{ flex: 1, minWidth: 0 }}>
          <Text
            fw={notification.is_read ? 500 : 700}
            size="sm"
            lh={1.45}
            style={{ letterSpacing: '-0.005em' }}
            c={semanticColors.text.primary}
          >
            {notification.title}
          </Text>
          <Text size="xs" lh={1.5} c={semanticColors.text.secondary} mt={4} lineClamp={2}>
            {notification.message}
          </Text>
          <Text
            size="xs"
            fw={500}
            mt={6}
            c={notification.is_read ? semanticColors.text.muted : 'coral.6'}
            style={{ letterSpacing: '0.02em', fontSize: '0.7rem' }}
          >
            {formatRelativeTime(notification.created_at)}
          </Text>
        </Box>
      </UnstyledButton>

      <Box className={classes.end}>
        {!notification.is_read && <Box className={classes.dot} />}
        <ActionIcon
          className={classes.delete}
          size="sm"
          variant="subtle"
          color="gray"
          onClick={() => onDelete(notification.id)}
          aria-label="Delete notification"
        >
          <IconX size={16} />
        </ActionIcon>
      </Box>
    </Box>
  );
};

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    priority: PropTypes.oneOf(['info', 'success', 'urgent']).isRequired,
    resource_type: PropTypes.string,
    resource_id: PropTypes.number,
    is_read: PropTypes.bool.isRequired,
    created_at: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default NotificationItem;
